import React, { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Calendar, List } from 'lucide-react';
import { FilterSection } from '../components/FilterSection';
import { WorkshopCard } from '../components/WorkshopCard';
import { QuoteCard } from '../components/QuoteCard';
import { stories } from '../data/stories';
export function Workshops() {
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get('type');
  const themeParam = searchParams.get('theme');
  const [view, setView] = useState<'list' | 'calendar'>('list');
  const [selectedTypes, setSelectedTypes] = useState<string[]>(typeParam ? [typeParam] : ['workshop', 'maekerscafe']);
  const [selectedThemes, setSelectedThemes] = useState<string[]>(themeParam ? [themeParam] : []);
  const [isOuderKind, setIsOuderKind] = useState(false);
  const [isEngelstalig, setIsEngelstalig] = useState(false);
  const workshops = [{
    id: '2',
    title: 'Parfum maken',
    date: 'za 01 feb 2026',
    time: '13:30 t/m 14:30',
    theme: 'Creativiteit',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 1),
    engelstalig: false
  }, {
    id: 'open-maekerscafe',
    title: 'Maekerscafé Draad',
    date: 'vr 04 feb 2026',
    time: '19:30 t/m 21:30',
    theme: 'Draad',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 4),
    engelstalig: false
  }, {
    id: 'maekerscafe-creative-meetup',
    title: 'Maekerscafé Creative meetup',
    date: 'za 07 feb 2026',
    time: '14:00 t/m 16:00',
    theme: 'Creativiteit',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 7),
    engelstalig: true
  }, {
    id: 'open-maekerscafe',
    title: 'Maekerscafé Draad',
    date: 'ma 09 feb 2026',
    time: '10:00 t/m 12:00',
    theme: 'Draad',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 9),
    engelstalig: false
  }, {
    id: '3',
    title: '2D naaldvilten in borduurring',
    date: 'di 10 feb 2026',
    time: '19:00 t/m 21:30',
    theme: 'Draad',
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 10),
    engelstalig: false
  }, {
    id: 'maekerscafe-draadgeluk',
    title: 'Maekerscafé Draadgeluk',
    date: 'wo 11 feb 2026',
    time: '10:00 t/m 12:00',
    theme: 'Draad',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 11),
    engelstalig: false
  }, {
    id: '4',
    title: 'Tuinontwerp: maak je eigen tuinplan',
    date: 'do 12 feb 2026',
    time: '19:00 t/m 22:00',
    theme: 'Planten',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 12),
    engelstalig: false
  }, {
    id: 'open-maekerscafe',
    title: 'Maekerscafé Draad',
    date: 'ma 16 feb 2026',
    time: '19:30 t/m 21:30',
    theme: 'Draad',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 16),
    engelstalig: false
  }, {
    id: '5',
    title: 'Strandhuisje voor muis – ouder-kind workshop',
    date: 'di 17 feb 2026',
    time: '10:00 t/m 12:00',
    theme: 'Keramiek',
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 17),
    engelstalig: false
  }, {
    id: '6',
    title: 'Drukken met Lego® Letterpress – ouder-kind workshop',
    date: 'di 17 feb 2026',
    time: '14:00 t/m 16:00',
    theme: 'Papier',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 17),
    engelstalig: false
  }, {
    id: '7',
    title: 'Fermenteren: maak je eigen Kombucha met Selia&Scob',
    date: 'di 17 feb 2026',
    time: '19:00 t/m 21:30',
    theme: 'Creativiteit',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 17),
    engelstalig: false
  }, {
    id: '8',
    title: 'Ontbijtbordjes in keramiek – ouder-kind workshop',
    date: 'wo 18 feb 2026',
    time: '13:30 t/m 16:00',
    theme: 'Keramiek',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 18),
    engelstalig: false
  }, {
    id: '9',
    title: 'Dierenvaasje en beeldjes in keramiek – ouder-kind workshop',
    date: 'do 19 feb 2026',
    time: '10:00 t/m 13:30',
    theme: 'Keramiek',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 19),
    engelstalig: false
  }, {
    id: '10',
    title: 'Chipskommetjes in keramiek – ouder-kind workshop',
    date: 'do 19 feb 2026',
    time: '13:30 t/m 16:00',
    theme: 'Keramiek',
    volzet: true,
    type: 'workshop' as const,
    sortDate: new Date(2026, 1, 19),
    engelstalig: false
  }, {
    id: 'maekerscafe-draadgeluk',
    title: 'Maekerscafé Draadgeluk',
    date: 'vr 20 feb 2026',
    time: '19:30 t/m 21:30',
    theme: 'Draad',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 20),
    engelstalig: false
  }, {
    id: 'maekerscafe-creative-meetup',
    title: 'Maekerscafé Creative meetup',
    date: 'za 21 feb 2026',
    time: '14:00 t/m 16:00',
    theme: 'Creativiteit',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 21),
    engelstalig: true
  }, {
    id: 'open-maekerscafe',
    title: 'Maekerscafé Draad',
    date: 'za 22 feb 2026',
    time: '10:00 t/m 12:00',
    theme: 'Draad',
    type: 'maekerscafe' as const,
    sortDate: new Date(2026, 1, 22),
    engelstalig: false
  }];
  const filteredWorkshops = useMemo(() => {
    let filtered = workshops;
    if (selectedTypes.length > 0) {
      filtered = filtered.filter(w => selectedTypes.includes(w.type));
    }
    if (selectedThemes.length > 0) {
      filtered = filtered.filter(w => selectedThemes.includes(w.theme));
    }
    if (isOuderKind) {
      filtered = filtered.filter(w => w.title.toLowerCase().includes('ouder-kind'));
    }
    if (isEngelstalig) {
      filtered = filtered.filter(w => w.engelstalig);
    }
    return filtered.sort((a, b) => a.sortDate.getTime() - b.sortDate.getTime());
  }, [selectedTypes, selectedThemes, isOuderKind, isEngelstalig]);
  return <div className="container mx-auto px-4 py-10" data-id="element-1460">
      {/* Page header */}
      <div className="text-center mb-10" data-id="element-1461">
        <h1 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-1462">Kalender</h1>
        <p className="text-gray-600" data-id="element-1463">
          Een overzicht van onze komende workshops en maekerscafés
        </p>
      </div>

      {/* Workshop testimonial */}
      <div className="max-w-2xl mx-auto mb-10" data-id="element-1464">
        <QuoteCard story={stories.filter(s => s.category === 'workshop')[0]} data-id="element-1465" />
      </div>

      {/* Sidebar + Content layout */}
      <div className="flex flex-col md:flex-row gap-8" data-id="element-1466">
        {/* Filter sidebar */}
        <div className="w-full md:w-64 flex-shrink-0" data-id="element-1467">
          <FilterSection onFilterChange={() => {}} resultCount={filteredWorkshops.length} selectedTypes={selectedTypes} onTypeChange={setSelectedTypes} selectedThemes={selectedThemes} onThemeChange={setSelectedThemes} isOuderKind={isOuderKind} onOuderKindChange={setIsOuderKind} isEngelstalig={isEngelstalig} onEngelstaligChange={setIsEngelstalig} data-id="element-1468" />
        </div>

        {/* Content area */}
        <div className="flex-1" data-id="element-1469">
          {/* Toolbar */}
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4" data-id="element-1470">
            <span className="text-sm text-gray-500" data-id="element-1471">
              {filteredWorkshops.length} resultaten
            </span>
            <div className="flex items-center gap-3" data-id="element-1472">
              <select className="border border-gray-300 rounded-md py-1.5 px-3 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-gray-300" data-id="element-1473">
                <option data-id="element-1474">Eerstvolgende</option>
                <option data-id="element-1475">A–Z</option>
                <option data-id="element-1476">Z–A</option>
              </select>
              <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-1477">
                <button onClick={() => setView('list')} className={`flex items-center gap-1.5 px-3 py-1.5 text-sm transition-colors duration-150 focus:outline-none ${view === 'list' ? 'bg-gray-800 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`} data-id="element-1478">
                  <List size={16} data-id="element-1479" />
                  Lijst
                </button>
                <button onClick={() => setView('calendar')} className={`flex items-center gap-1.5 px-3 py-1.5 text-sm border-l border-gray-300 transition-colors duration-150 focus:outline-none ${view === 'calendar' ? 'bg-gray-800 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`} data-id="element-1480">
                  <Calendar size={16} data-id="element-1481" />
                  Kalender
                </button>
              </div>
            </div>
          </div>

          {view === 'list' ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1482">
              {filteredWorkshops.length > 0 ? filteredWorkshops.map((workshop, index) => <WorkshopCard key={`${workshop.id}-${index}`} {...workshop} data-id="element-1483" />) : <div className="col-span-full text-center py-12 text-gray-400" data-id="element-1484">
                  Geen resultaten gevonden voor de geselecteerde filters.
                </div>}
            </div> : <div className="border border-dashed border-gray-300 p-4 rounded-md bg-gray-50" data-id="element-1485">
              <div className="grid grid-cols-7 gap-2" data-id="element-1486">
                {['Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za', 'Zo'].map(day => <div key={day} className="text-center font-medium text-sm p-2 border-b border-gray-200" data-id="element-1487">
                    {day}
                  </div>)}
                {Array.from({
              length: 28
            }, (_, i) => i + 1).map(date => {
              const showMaekerscafe = selectedTypes.length === 0 || selectedTypes.includes('maekerscafe');
              const showWorkshop = selectedTypes.length === 0 || selectedTypes.includes('workshop');
              return <div key={date} className={`border border-gray-200 p-2 min-h-[80px] ${date % 7 === 0 ? 'bg-gray-100' : ''}`} data-id="element-1488">
                      <div className="text-xs text-gray-500 mb-1 font-medium" data-id="element-1489">
                        {date}
                      </div>
                      {date === 1 && showWorkshop && <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1490">
                          Parfum maken
                        </div>}
                      {(date === 4 || date === 9 || date === 16 || date === 22) && showMaekerscafe && <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1491">
                            Open Maekerscafé
                          </div>}
                      {date === 10 && showWorkshop && <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1492">
                          2D naaldvilten
                        </div>}
                      {date === 12 && showWorkshop && <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1493">
                          Tuinontwerp
                        </div>}
                      {date === 17 && showWorkshop && <>
                          <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1494">
                            Strandhuisje
                          </div>
                          <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1495">
                            Lego® Letterpress
                          </div>
                          <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1496">
                            Kombucha
                          </div>
                        </>}
                      {date === 18 && showWorkshop && <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1497">
                          Ontbijtbordjes
                        </div>}
                      {date === 19 && showWorkshop && <>
                          <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1498">
                            Dierenvaasje
                          </div>
                          <div className="bg-gray-200 p-1 text-xs rounded mb-1 cursor-pointer hover:bg-gray-300 transition-colors duration-150" data-id="element-1499">
                            Chipskommetjes
                          </div>
                        </>}
                    </div>;
            })}
              </div>
            </div>}
        </div>
      </div>
    </div>;
}